module.exports = __webpack_public_path__ + "static/media/Approved.aa23082c.svg";